import { CheckmarkFilled, InProgress, CircleDash } from '@carbon/react/icons';
import classNames from 'classnames';
import styles from './review-status-icon.module.scss';

// The three-state review glyph — green check (all reviewed), blue in-progress
// (some), gray dash (none) — shared by the card's interpretation review icon and
// the party Source indicator, so the status→icon mapping lives in one place.
// Each caller maps its own enum to a status and passes its positioning class.
export type ReviewGlyphStatus = 'reviewed' | 'partial' | 'pending';

export const ReviewStatusIcon = ({
  status,
  className,
  showPending = true,
  partialLabel = 'Partially reviewed',
}: {
  status: ReviewGlyphStatus;
  className?: string;
  // The Source indicator renders nothing when none are reviewed; the card shows a dash.
  showPending?: boolean;
  partialLabel?: string;
}) => {
  if (status === 'reviewed')
    return (
      <CheckmarkFilled
        className={classNames(styles.reviewed, className)}
        aria-label="Reviewed"
      />
    );
  if (status === 'partial')
    return (
      <InProgress
        className={classNames(styles.partial, className)}
        aria-label={partialLabel}
      />
    );
  return showPending ? (
    <CircleDash
      className={classNames(styles.pending, className)}
      aria-label="Not reviewed"
    />
  ) : null;
};
